const CryptoMarketContentTwo = () => {
  return (
    <div className="how__work__market">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>Key Factors Affecting Cryptocurrencies</h2>

                <p>
                  Cryptocurrency prices are influenced by a complex mix of
                  technology, sentiment, and macroeconomic trends. Here are four
                  major drivers every trader should understand:
                </p>
              </div>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/markets/crypto_cfd/crypto_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Market Demand & Adoption</h3>
              <p>
                The wider a cryptocurrency is adopted by investors, businesses,
                or institutions, the more stable and valuable it tends to
                become. Network effects, partnerships, and mainstream usage all
                drive long-term growth.
              </p>
              <hr className="black-line" />

              <h3>Regulatory Developments</h3>
              <p>
                Government policies and legal frameworks can significantly
                impact crypto prices. Positive regulation enhances credibility,
                while uncertainty can cause volatility.
              </p>
              <hr className="black-line" />

              <h3>Technological Advancements</h3>
              <p>
                Updates in blockchain protocols, security upgrades, or the
                launch of new features (like Ethereum’s transition to
                proof-of-stake) can directly affect market sentiment and asset
                value.
              </p>yy
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CryptoMarketContentTwo;
